'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');

const contentSection = "_content-section_cfhsv_1";
const styles = {
	contentSection: contentSection
};

const ContentSection = ({ children, size = "small" }) => jsxRuntime.jsx("div", { className: styles.contentSection, "data-size": size, "data-zds": true, children });

exports.ContentSection = ContentSection;
//# sourceMappingURL=ContentSection.cjs.js.map
